var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CategoryAsideBlock",
        { staticClass: "filter-list", attrs: { title: _vm.filterTitle } },
        _vm._l(_vm.filterList, function(filter) {
          return _c(
            "div",
            { key: filter.key, staticClass: "filter-list__block" },
            [
              _c(filter.component, _vm._b({ tag: "div" }, "div", filter, false))
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }